<template>
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <basic-bread-crumb v-show="$route.path.search('basic')!==-1"></basic-bread-crumb>
      <order-bread-crumb v-show="$route.path.search('order')!==-1"></order-bread-crumb>
      <stock-bread-crumb v-show="$route.path.search('stock')!==-1"></stock-bread-crumb>
      <report-bread-crumb v-show="$route.path.search('report')!==-1"></report-bread-crumb>
      <aftersale-bread-crumb v-show="$route.path.search('afterSale')!==-1"></aftersale-bread-crumb>
      <user-set-crumb v-show="$route.path.search('user')!==-1"></user-set-crumb>
    </el-breadcrumb>
  </div>
</template>
<script>
import basicBreadCrumb from './basicBreadCrumb'
import orderBreadCrumb from './orderBreadCrumb'
import stockBreadCrumb from './stockBreadCrumb'
import reportBreadCrumb from './reportBreadCrumb'
import aftersaleBreadCrumb from './aftersaleBreadCrumb'
import userSetCrumb from './userSet'
export default {
  components: { basicBreadCrumb, orderBreadCrumb, stockBreadCrumb, reportBreadCrumb, aftersaleBreadCrumb, userSetCrumb },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.breadcrumb {
  position: fixed;
  top: 48px;
  bottom: 0;
  width: 100%;
  background-color: #f5f7fa;
  z-index: 1;
  padding: 11px 0px 0 188px;
  .el-breadcrumb__item.active .el-breadcrumb__inner.is-link {
    color: #ff6224 !important;
    font-weight: 700 !important;
  }
  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    font-weight: 400 !important;
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link {
    cursor: pointer;
  }
  .el-breadcrumb__inner.is-link:hover {
    color: #ff6224;
    font-weight: 700 !important;
  }
  .closeCurrntPage {
    border-radius: 10px;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    font-size: 14px;
    position: fixed;
    right: 16px;
    top: 53px;
    text-align: center;
    width: 94px;
    height: 20px;
    border-radius: 5px;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/breadcrumb.vue